var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.308273 7.29289C-0.0822487 7.68342 -0.0822487 8.31658 0.308273 8.70711L6.67223 15.0711C7.06276 15.4616 7.69592 15.4616 8.08645 15.0711C8.47697 14.6805 8.47697 14.0474 8.08645 13.6569L2.4296 8L8.08645 2.34315C8.47697 1.95262 8.47697 1.31946 8.08645 0.928932C7.69592 0.538408 7.06276 0.538408 6.67223 0.928932L0.308273 7.29289ZM44.0154 7L1.01538 7V9L44.0154 9V7Z",
    fill: "#167092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blueArrow.7301f4b307de7dd1398020aeeb14b425.svg";
export { ForwardRef as ReactComponent };